import { render, staticRenderFns } from "./EmdFooter.vue?vue&type=template&id=1a498544&scoped=true&"
import script from "./EmdFooter.vue?vue&type=script&lang=js&"
export * from "./EmdFooter.vue?vue&type=script&lang=js&"
import style0 from "./EmdFooter.vue?vue&type=style&index=0&id=1a498544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a498544",
  null
  
)

/* custom blocks */
import block0 from "./EmdFooter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a498544')) {
      api.createRecord('1a498544', component.options)
    } else {
      api.reload('1a498544', component.options)
    }
    module.hot.accept("./EmdFooter.vue?vue&type=template&id=1a498544&scoped=true&", function () {
      api.rerender('1a498544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/organisms/EmdFooter.vue"
export default component.exports